export default __webpack_public_path__ + "static/P_SearchThumb_MobileRouter-f1a8899bc6f1b2ca43a796866f16b4fa.webp";